<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <v-bottom-sheet v-model="sheet" inset persistent max-width="500" hide-overlay>
        <v-sheet class="text-center" height="150px">
            <v-container fluid>
                <v-layout>
                    <v-col cols="12" md12 class="ma-0 pa-0">
                        <div>Выбрано пользователей {{selected.length}}</div>
                    </v-col>
                </v-layout>
                <v-layout>
                    <v-row justify="center" align="center">
                        <v-col cols="12" class="pt-1">
                            <v-select
                                    :disabled="filteredMailingGroups.length === 0"
                                    :items="filteredMailingGroups"
                                    label="Выберите группу"
                                    v-model="selectedMailingGroup"
                                    value="1"
                                    item-text="title"
                                    item-value="id"
                                    hide-details
                            ></v-select>

                        </v-col>
                        <v-col cols="1" md2 class="ma-0 pa-0" v-if="filteredMailingGroups.length === 0">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon v-on="on" color="error">error</v-icon>
                                </template>
                                <span>Создайте группы</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-layout>
                <v-layout>
                    <v-row justify="center" class="ma-0 pa-0">
                        <v-btn
                                class="mt-0"
                                text
                                color="primary"
                                :disabled="selectedMailingGroup === 1"
                                @click="addClients"
                        >
                            Добавить в группу
                        </v-btn>
                        <v-btn
                                class="mt-0"
                                text
                                color="error"
                                @click="removeClients"
                                :disabled="mailingGroupId === 0"
                        >
                            Удалить
                        </v-btn>
                    </v-row>
                </v-layout>
            </v-container>
        </v-sheet>

    </v-bottom-sheet>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ClientBottomBar',
    props: ['selected', 'mailingGroupId'],
    data() {
        return {
            selectedMailingGroup: 1
        }
    },
    computed: {
        ...mapGetters({
            getMailingGroups: 'clients/mailingGroups'
        }),
        sheet: {
            get() {
                return this.selected.length > 0
            },
            set() {
            }
        },
        filteredMailingGroups() {
            return this.getMailingGroups.filter(getMailingGroups => getMailingGroups.id !== this.mailingGroupId)
        }
    },
    methods: {
        addClients() {
            let userIds = []
            for (let i = 0; i < this.selected.length; i++) {
                userIds.push(this.selected[i].user_id)
            }
            this.$store.dispatch('clients/addClientsToMailingGroup',
                {
                    userIds: userIds,
                    mailingGroupId: this.selectedMailingGroup,
                    botId: this.$route.params['pathMatch']
                }).then(response => {
                if (typeof response === 'object') {
                    this.$emit('addClientsNotification', { text: response.success.text, color: 'success' })
                }
            })
            this.$emit('clearSelected')
        },
        removeClients() {
            let clientIds = []
            for (let i = 0; i < this.selected.length; i++) {
                clientIds.push(this.selected[i].user_id)
            }
            let groupId = this.$route.params.hasOwnProperty('groupId') ? this.$route.params.groupId : 0
            this.$store.dispatch('clients/removeClientsInMailingGroup',
                {
                    clientIds: clientIds,
                    mailingGroupId: groupId,
                    botId: this.$route.params['pathMatch']
                }).then(response => {
                if (typeof response === 'object') {
                    this.$emit('addClientsNotification', { text: response.success.text, color: 'success' })
                }
            })
            this.$emit('clearSelected')
        }
    }
}
</script>

<style scoped>

</style>
